<div id="scrollableImage" class="wrapper">
  <h1 class="h5">{{ title }}</h1>
  <h2 class="body">{{ subtitle }}</h2>
  <img
    [preloadImage]="(image$ | async)?.imageUrl"
    (load)="setHeight()"
    [alt]="title"
    />
</div>

<div class="overlay" [class.lifted]="overlayLifted"></div>

@if (button) {
  <div class="button-wrapper">
    <page-button [config]="button" (clicked)="buttonAction.emit()"></page-button>
  </div>
}
